<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content #dialogContent>
  <p *ngIf="!name" class="mat-body">
    {{content}}
  </p>
  <p *ngIf="name" class="mat-body">
    {{itemType}} "<span class="name" [matTooltip]="name">{{name}}</span>" {{actionDesc}}.
  </p>
  <p class="mat-body" i18n="Confirm Modal|Confirm modal prompt@@confirm-modal-prompt">Do you want to proceed?</p>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button [destructive]="true"
              [disabled]="inProgress"
              (clicked)="proceed()"
              [label]="action"></app-button>
</div>
